import React, { useContext } from 'react';
import ViewportContext from '../../../../components/viewport/context';
import { Direction } from './types';
import * as S from './styles';

type OwnProps = {
  direction?: Direction;
  icon?: string;
  items: { id: number; width: number; height: number }[];
};

const Placeholder = ({ direction = Direction.ROW, icon, items }: OwnProps) => {
  const { isMobile, isTablet } = useContext(ViewportContext);

  return (
    <S.Placeholder direction={direction}>
      {icon && (
        <S.Icon>
          <S.Image alt="" src={icon} />
        </S.Icon>
      )}
      <S.Lines>
        {items.map((item, index) => {
          return (
            <>
              {(isMobile || isTablet) && index === 1 && (
                <S.ToggleSearchButton />
              )}
              <S.Item key={item.id} width={item.width} height={item.height} />
            </>
          );
        })}
      </S.Lines>
    </S.Placeholder>
  );
};

export default Placeholder;
